import type { FaireProductEntity } from "../../entity_types/product";

export const p_g7zdb8b2xd: FaireProductEntity = {
  token: "p_g7zdb8b2xd",
  type: "product",
  name: "Everything Stunk Before You Kitchen Towel",
  brandToken: "b_4knjkc8j",
  brandName: "Primitives by Kathy",
  imageUrl: "https://cdn.faire.com/fastly/216d2748d7ad7171794e7f35ec0c143ac4df74e74b717b629fd3848c5916f3a0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/cc1dfe1b3e56f03396b8dbde8fc800f8f96fe933b698cc0d5ee24079ed2c5c78.jpeg",
    "https://cdn.faire.com/fastly/84aba8e55326fe4484419bc3a54e41c57aba8c1a352b6cf5d6643b169ad734b2.jpeg",
    "https://cdn.faire.com/fastly/2b431975cecf69bffac1a681bb1b9270e2576bbfb03b25eaadce91cae06a72e5.jpeg",
    "https://cdn.faire.com/fastly/04a098ba735c45dd4113539d7cf30c1e157199f25c2e22690d9603db426d2214.jpeg",
    "https://cdn.faire.com/fastly/db0a01f7cd842627d37568a582f11232d8e8c6f928cbcea9b6dc3d82d78982b8.jpeg",
    "https://cdn.faire.com/fastly/0a327f95cf0333e8bac7efac50a3451e0ced95d8435cef515b37f39fe6944893.jpeg"
  ],
  priceDollars: 8,
  description: "A microfiber kitchen towel from our Valentine's Day Collection featuring an all-over design displaying a pattern of skunks, flowers, and hearts with a funny love-themed sentiment that reads \"Everything Stunk Before You.\" Skunk inspired pattern is replicated from playful hand illustrated artwork. Double-sided towel displays a coordinating black and white checker pattern on the back that offers multiple display options with a cotton tape hanger in the corner for hanging. Our Everything Stunk Before You kitchen towel is conveniently machine washable for easy cleaning. Microfiber towel is packaged on a cardboard hanger with hole to easily display on store rack. A fun love-themed gift perfect for both friends and partners on Valentine's Day or in everyday moments.",
  tags: [],
  msrpDollars: 15.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:04:19.978Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
